/* TomoeGlow — comportements custom de la bannière cookies native.
   1) Titre localisé façon "Salut c'est nous... les Cookies !" selon la
      langue de la page (fallback : navigateur puis anglais).
   2) Verrou modal sur petits écrans : tant que la bannière (ou la modale
      de préférences) est visible, classe `tg-cookie-open` sur <html> +
      backdrop #tg-cookie-backdrop. Le CSS limite l'effet à ≤ 480 px.
   3) Redirection de langue à la PREMIÈRE visite : navigateur français sur
      la version anglaise → /fr (trafic organique : un seul lien pour tous).
      Le choix est mémorisé — un retour manuel vers l'anglais via le
      sélecteur n'est jamais re-forcé. Les robots (navigateur en-US) ne
      sont pas concernés → zéro impact SEO/hreflang. */
(function () {
  'use strict';
  try {
    var KEY = 'tgLangPref';
    /* pas de redirection sur la page carte-cadeau (URLs à jeton) */
    var isGiftCard = document.body && document.body.className.indexOf('gift-card') > -1;
    if (!localStorage.getItem(KEY) && !isGiftCard) {
      var pageLang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
      var navLang = (navigator.language || 'en').slice(0, 2).toLowerCase();
      /* la langue cible n'est valable que si Shopify la publie : le lien
         hreflang de la page courante sert de garde-fou ET fournit l'URL
         localisée exacte — s'active tout seul quand une langue est publiée */
      var alt = /^[a-z]{2}$/.test(navLang)
        ? document.querySelector('link[hreflang="' + navLang + '"]')
        : null;
      if (pageLang === navLang || !alt) {
        /* déjà dans la bonne langue, ou langue non proposée : on mémorise, on ne touche à rien */
        localStorage.setItem(KEY, pageLang);
      } else {
        /* première visite, langue du navigateur disponible → on y va */
        localStorage.setItem(KEY, navLang);
        location.replace(alt.href);
      }
    }
  } catch (e) { /* stockage bloqué (navigation ultra-privée) : aucune redirection */ }
})();

(function () {
  'use strict';

  var BACKDROP_ID = 'tg-cookie-backdrop';

  /* [surtitre, titre] par langue — langues les plus parlées du web ; fallback : anglais */
  var TITLES = {
    en: ["Hi, it's us...", 'the Cookies!'],
    fr: ["Salut, c'est nous...", 'les Cookies !'],
    es: ['Hola, somos...', '¡las Cookies!'],
    de: ["Hallo, wir sind's...", 'die Cookies!'],
    it: ['Ciao, siamo noi...', 'i Cookie!'],
    pt: ['Olá, somos nós...', 'os Cookies!'],
    nl: ['Hoi, wij zijn het...', 'de Cookies!'],
    pl: ['Cześć, to my...', 'Ciasteczka!'],
    sv: ['Hej, det är vi...', 'Cookies!'],
    da: ['Hej, det er os...', 'Cookies!'],
    no: ['Hei, det er oss...', 'Cookies!'],
    nb: ['Hei, det er oss...', 'Cookies!'],
    fi: ['Hei, me täällä...', 'Evästeet!'],
    cs: ['Ahoj, to jsme my...', 'Cookies!'],
    sk: ['Ahoj, to sme my...', 'Cookies!'],
    ro: ['Salut, noi suntem...', 'Cookie-urile!'],
    hu: ['Szia, mi vagyunk...', 'a Sütik!'],
    el: ['Γεια, εμείς είμαστε...', 'τα Cookies!'],
    tr: ['Selam, biziz...', 'Çerezler!'],
    ru: ['Привет, это мы...', 'Куки!'],
    uk: ['Привіт, це ми...', 'Куки!'],
    ja: ['こんにちは…', 'クッキーです！'],
    zh: ['嗨，是我们…', 'Cookie！'],
    ko: ['안녕하세요...', '쿠키예요!'],
    ar: ['مرحباً، نحن...', 'الكوكيز!'],
    he: ['היי, זה אנחנו...', 'העוגיות!'],
    hi: ['नमस्ते, हम हैं...', 'कुकीज़!'],
    id: ['Hai, ini kami...', 'Cookie!'],
    th: ['สวัสดี เราคือ...', 'คุกกี้!'],
    vi: ['Chào bạn, là chúng tôi...', 'Cookie!'],
  };

  function localizeTitle() {
    var title = document.getElementById('shopify-pc__banner__body-title');
    if (!title || title.getAttribute('data-tg-localized')) return;
    title.setAttribute('data-tg-localized', '1');

    /* La langue de la PAGE (lang="fr" sur /fr) — pas celle du navigateur —
       pour que le titre soit toujours dans la même langue que le corps du
       texte fourni par Shopify. Fallback navigateur si l'attribut manque. */
    var lang = (document.documentElement.lang || navigator.language || 'en').slice(0, 2).toLowerCase();
    var pair = TITLES[lang] || TITLES.en;

    /* le titre d'origine reste présent, masqué visuellement, pour les lecteurs d'écran */
    var sr = document.createElement('span');
    sr.className = 'tg-c-sr';
    sr.textContent = title.textContent;

    var sur = document.createElement('span');
    sur.className = 'tg-c-sur';
    sur.setAttribute('aria-hidden', 'true');
    sur.textContent = pair[0];

    var big = document.createElement('span');
    big.className = 'tg-c-big';
    big.setAttribute('aria-hidden', 'true');
    big.textContent = pair[1];

    title.textContent = '';
    title.appendChild(sr);
    title.appendChild(sur);
    title.appendChild(big);
  }

  /* Retire la mention "Shopify" du texte de la bannière (toutes langues).
     Ex. "We and our partners, including Shopify, use cookies…"
       → "We and our partners use cookies…"
     Idempotent : ne touche que les nœuds texte contenant encore "Shopify". */
  function scrubShopify(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('Shopify') === -1) continue;
      node.nodeValue = node.nodeValue
        /* supprime la proposition entre virgules : ", including Shopify," /
           ", y compris Shopify," / ", einschließlich Shopify," … */
        .replace(/,[^,.]{0,50}\bShopify\b[^,.]{0,20},/g, '')
        /* filet de sécurité : occurrence résiduelle isolée */
        .replace(/\s*,?\s*\bShopify\b/g, '')
        .replace(/\s{2,}/g, ' ');
    }
  }

  function isVisible(el) {
    return !!el && el.isConnected && window.getComputedStyle(el).display !== 'none';
  }

  function lock() {
    document.documentElement.classList.add('tg-cookie-open');
    if (!document.getElementById(BACKDROP_ID)) {
      var bd = document.createElement('div');
      bd.id = BACKDROP_ID;
      bd.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bd);
    }
  }

  function unlock() {
    document.documentElement.classList.remove('tg-cookie-open');
    var bd = document.getElementById(BACKDROP_ID);
    if (bd) bd.remove();
  }

  function sync() {
    var banner = document.getElementById('shopify-pc__banner');
    var prefs = document.getElementById('shopify-pc__prefs');
    if (banner) {
      localizeTitle();
      scrubShopify(banner.querySelector('.shopify-pc__banner__body') || banner);
    }
    if (prefs) scrubShopify(prefs);
    if (isVisible(banner) || isVisible(prefs)) {
      lock();
    } else {
      unlock();
    }
  }

  /* Débounce sur requestAnimationFrame : l'observer peut tirer très souvent. */
  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  }

  var mo = new MutationObserver(scheduleSync);
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
